var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("dataScreening", {
            attrs: {
              isDisabled: _vm.reqLoading,
              propsData: {
                isCountry: false,
                adChannel: false,
                adPlacement: false
              }
            },
            on: { searchChange: _vm.searchChange }
          }),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    disabled: _vm.reqLoading,
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("pleaseSelectNewOrActiveUser")
                  },
                  model: {
                    value: _vm.searchData.user_type,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "user_type", $$v)
                    },
                    expression: "searchData.user_type"
                  }
                },
                _vm._l(_vm.deviceList, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm.rawData.game_mark.indexOf("yjfm") == -1
            ? [
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: {
                          disabled: _vm.reqLoading,
                          filterable: "",
                          placeholder: _vm.$t("pleaseChoose")
                        },
                        on: { change: _vm.getServer },
                        model: {
                          value: _vm.paramsData.is_prod,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "is_prod", $$v)
                          },
                          expression: "paramsData.is_prod"
                        }
                      },
                      _vm._l(_vm.severlist, function(item) {
                        return _c("el-option", {
                          key: item.label,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: {
                          disabled: _vm.reqLoading,
                          multiple: "",
                          "collapse-tags": "",
                          clearable: "",
                          filterable: "",
                          placeholder: _vm.$t("pleaseSelectServer")
                        },
                        on: { change: _vm.YjfmSeverChange },
                        model: {
                          value: _vm.paramsData.server_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "server_id", $$v)
                          },
                          expression: "paramsData.server_id"
                        }
                      },
                      [
                        _c(
                          "el-checkbox",
                          {
                            on: { change: _vm.selectYjfmAll },
                            model: {
                              value: _vm.checked,
                              callback: function($$v) {
                                _vm.checked = $$v
                              },
                              expression: "checked"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("selectAll")))]
                        ),
                        _vm._l(_vm.serverList, function(item) {
                          return _c("el-option", {
                            key: item.serverID,
                            attrs: {
                              label: item.serverName,
                              value: item.serverID
                            }
                          })
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              ]
            : [
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: {
                          disabled: _vm.reqLoading,
                          filterable: "",
                          placeholder: _vm.$t("pleaseChoose")
                        },
                        on: { change: _vm.envIdChange },
                        model: {
                          value: _vm.paramsData.env_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "env_id", $$v)
                          },
                          expression: "paramsData.env_id"
                        }
                      },
                      _vm._l(_vm.szgmEnv, function(item) {
                        return _c("el-option", {
                          key: item.label,
                          attrs: { label: item.label, value: item.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          disabled: _vm.reqLoading,
                          filterable: "",
                          placeholder: _vm.$t("serverChannel")
                        },
                        on: { change: _vm.serverChange },
                        model: {
                          value: _vm.server_channel,
                          callback: function($$v) {
                            _vm.server_channel = $$v
                          },
                          expression: "server_channel"
                        }
                      },
                      _vm._l(_vm.serverChannel, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          disabled: _vm.reqLoading,
                          clearable: "",
                          filterable: "",
                          placeholder: _vm.$t("showTestServer")
                        },
                        on: { change: _vm.serverChannelChange },
                        model: {
                          value: _vm.show_test,
                          callback: function($$v) {
                            _vm.show_test = $$v
                          },
                          expression: "show_test"
                        }
                      },
                      _vm._l(_vm.serverType, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          disabled: _vm.reqLoading,
                          multiple: "",
                          "collapse-tags": "",
                          filterable: "",
                          clearable: "",
                          placeholder: _vm.$t("server")
                        },
                        on: { change: _vm.severChange },
                        model: {
                          value: _vm.paramsData.server_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "server_id", $$v)
                          },
                          expression: "paramsData.server_id"
                        }
                      },
                      [
                        _c(
                          "el-checkbox",
                          {
                            on: { change: _vm.selectAll },
                            model: {
                              value: _vm.checked,
                              callback: function($$v) {
                                _vm.checked = $$v
                              },
                              expression: "checked"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("selectAll")))]
                        ),
                        _vm._l(_vm.serverListYJ, function(item) {
                          return _c("el-option", {
                            key: item.serverID,
                            attrs: {
                              label: item.serverName,
                              value: item.serverID
                            }
                          })
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  disabled: _vm.reqLoading,
                  clearable: "",
                  placeholder: _vm.$t("productId")
                },
                model: {
                  value: _vm.searchData.product_ids,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "product_ids", $$v)
                  },
                  expression: "searchData.product_ids"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticStyle: { position: "relative" }, attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  disabled: _vm.reqLoading,
                  clearable: "",
                  placeholder: _vm.$t("customDays")
                },
                model: {
                  value: _vm.searchData.churn_days,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "churn_days", $$v)
                  },
                  expression: "searchData.churn_days"
                }
              }),
              _c(
                "el-tooltip",
                {
                  staticClass: "tipss",
                  attrs: { effect: "dark", placement: "top" }
                },
                [
                  _c("div", {
                    attrs: { slot: "content" },
                    domProps: { innerHTML: _vm._s(_vm.$t("customRangeTip")) },
                    slot: "content"
                  }),
                  _c("i", { staticClass: "el-icon-question " })
                ]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    disabled: _vm.reqLoading,
                    placeholder: _vm.$t("displayMode")
                  },
                  model: {
                    value: _vm.displayMode,
                    callback: function($$v) {
                      _vm.displayMode = $$v
                    },
                    expression: "displayMode"
                  }
                },
                [
                  _c("el-option", {
                    attrs: { label: _vm.$t("countSlashRatio"), value: "both" }
                  }),
                  _c("el-option", {
                    attrs: { label: _vm.$t("personCount"), value: "count" }
                  }),
                  _c("el-option", {
                    attrs: { label: _vm.$t("ratioLabel"), value: "ratio" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.tableData.length },
                  on: { click: _vm.exportdata }
                },
                [_vm._v(_vm._s(_vm.$t("export")))]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: { click: _vm.searchClick }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.tableData.length
        ? _c(
            "el-table",
            {
              directives: [
                {
                  name: "sticky-table-header",
                  rawName: "v-sticky-table-header",
                  value: 0,
                  expression: "0"
                }
              ],
              ref: "tableRef",
              attrs: { id: "tableRef", data: _vm.tableData, border: "" }
            },
            _vm._l(_vm.tableList, function(item, index) {
              return _c("el-table-column", {
                key: index,
                attrs: {
                  label: item.label,
                  prop: item.prop,
                  fixed: index == 0,
                  "min-width": 130,
                  "render-header": function(h, obj) {
                    return _vm.renderheader(h, obj, item.desc)
                  }
                }
              })
            }),
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }